function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  id: "f102a",
  d: "M1164.495 454.44c-1.716 0-3.089-1.32-3.089-2.97 0-1.65 1.373-2.97 3.089-2.97s3.089 1.32 3.089 2.97c0 1.65-1.373 2.97-3.089 2.97zm.005-7.44c-4.719 0-7.5 4.47-7.5 4.47s2.781 4.47 7.5 4.47c4.719 0 7.5-4.47 7.5-4.47s-2.781-4.47-7.5-4.47z"
}), React.createElement("path", {
  id: "f102b",
  d: "M1164 451.93c0-.514.434-.93.97-.93s.97.416.97.93-.434.93-.97.93-.97-.416-.97-.93z"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", {
  transform: "translate(-1157 -447)"
}, React.createElement("g", null, React.createElement("g", null, React.createElement("use", {
  xlinkHref: "#f102a"
})), React.createElement("g", null, React.createElement("use", {
  xlinkHref: "#f102b"
})))));

var SvgEye = function SvgEye(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 15,
    height: 9,
    viewBox: "0 0 15 9",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgEye, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/eye.6a31e2c2.svg";
export { ForwardRef as ReactComponent };